import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./utils/axios-config";
import $scroll from "@utils/loading";
import store from "./store";
import "@assets/css/base.css";
import "@assets/css/reset.css";
import "@assets/css/style.css";
import "amfe-flexible";
import * as webSocketManager from '@/utils/webSocketManager';
import vuescroll from "vue-scroll";
import VEmojiPicker from 'v-emoji-picker';

// Vant 组件
import {
  Popup, Tab, Tabs, Form, Field, Dialog, CellGroup, Button, Cascader,
  ActionSheet, Tag, Toast, Picker, Card, Badge, Grid, GridItem,
  NoticeBar, ImagePreview, Overlay, Loading
} from "vant";

// 弹窗
import { Alert, Confirm } from 'wc-messagebox';
import 'wc-messagebox/style.css';

// 特效
import confetti from 'canvas-confetti';
import VueBeautifulChat from 'vue-beautiful-chat';

// 音频
import { music } from '@/libs/music';

import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/check'

Vue.component('icon', Icon)

Vue.config.productionTip = false;

// === 注册全局组件 ===
Vue.use(vuescroll);
Vue.use(VEmojiPicker);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Form);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(Cascader);
Vue.use(ActionSheet);
Vue.use(Tag);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(Card);
Vue.use(Badge);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(NoticeBar);
Vue.use(ImagePreview);
Vue.use(Overlay);
Vue.use(Loading);

Vue.use(Alert);
Vue.use(Confirm);
Vue.use(VueBeautifulChat);

// === 挂载原型 ===
Vue.prototype.$confetti = confetti;
Vue.prototype.$Bus = new Vue();
Vue.prototype.$toast = Toast;
Vue.prototype.$scroll = $scroll;
Vue.prototype.$webSocketManager = webSocketManager;
Vue.prototype.$createjs = window.createjs;

// === 音频初始化 ===
const audioResources = {
  newMsg: {
    type: 'effect',
    url: require('@/assets/audio/newmsg.mp3')
  }
};

music.init(audioResources);
Vue.prototype.$music = music;

// ============ 🆕 修改：关闭加载动画的逻辑移到 App.vue 的 mounted 里 ============
// 原因：Vue2 的 $mount() 不接收回调，第二个参数会被当成 SSR 的 hydrating 布尔值，
// 你原来传的回调函数永远不会执行，window.finishLoading() 也就永远不会被调用。
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
